"use client";

import React, { useEffect, useState } from "react";
import NextImage from "next/image";
import Typography from "@/components/Typography";
import Link from "@/components/Link";
import IconButton from "@/components/IconButton";
import { LinkIcon, MailIcon, TelegramIcon, VkIcon } from "@/components/Icon";
import styles from "../../styles.module.css";

export default function ShareSection() {
  const [currentURL, setCurrentURL] = useState("");
  useEffect(() => {
    setCurrentURL(window.location.href);
  }, []);

  return (
    <section
      className={`${styles.article__section} ${styles.article__section__share}`}
    >
      <Typography
        variant="p2"
        className={`${styles.article__section__share__text}`}
      >
        Поделиться
      </Typography>
      <div className={`${styles.article__section__share__icons}`}>
        <IconButton
          variant="circle"
          Icon={TelegramIcon}
          className={`${styles.article__section__share__icon}`}
          asChild
        >
          <Link
            href={`https://t.me/share/url?url=${currentURL}`}
            target="_blank"
          />
        </IconButton>
        <IconButton
          variant="circle"
          Icon={VkIcon}
          className={`${styles.article__section__share__icon}`}
          asChild
        >
          <Link
            href={`https://vk.com/share.php?url=${currentURL}`}
            target="_blank"
          />
        </IconButton>
        <IconButton
          variant="circle"
          Icon={MailIcon}
          className={`${styles.article__section__share__icon}`}
          asChild
        >
          <Link href={`mailto:?body=${currentURL}`} />
        </IconButton>
        <IconButton
          variant="circle"
          Icon={LinkIcon}
          className={`${styles.article__section__share__icon}`}
          onClick={() => {
            navigator.clipboard.writeText(currentURL);
          }}
        />
      </div>
    </section>
  );
}
